/**
 * Admin reports queries — prompt-tuning reports + content-gap reports.
 *
 * Both tables have RLS enabled with no policies — reads go through the
 * SECURITY DEFINER list RPCs, writes go through the generate-* edge
 * functions (which use the service-role client internally).
 */
import { supabase } from '@/lib/supabase'
import { invokeEdgeJson } from '../_edge'
import { GENERATE_PROMPT_TUNING_REPORT, GENERATE_CONTENT_GAP_REPORT } from '../_endpoints'
import { ADMIN_REPORT_LIMIT } from '../_constants'

// ── Prompt Tuning Reports ──────────────────────────────────────

/** Fetch past prompt tuning reports, newest first. Uses a SECURITY DEFINER
 *  RPC (admin_list_prompt_tuning_reports) because the table has RLS enabled
 *  with no policies — direct client reads return empty. */
export async function fetchPromptTuningReports(limit = ADMIN_REPORT_LIMIT) {
  const { data, error } = await supabase.rpc('admin_list_prompt_tuning_reports', { p_limit: limit })
  if (error) throw error
  return data || []
}

/** Trigger the prompt-tuning-report edge function on demand (admin button). */
export async function generatePromptTuningReportNow() {
  return invokeEdgeJson(
    GENERATE_PROMPT_TUNING_REPORT,
    {},
    {
      errorMessage: 'Failed to generate prompt-tuning report',
    }
  )
}

// ── Content Gap Reports ────────────────────────────────────────

/** Fetch past content gap reports, newest first. */
export async function fetchContentGapReports(limit = ADMIN_REPORT_LIMIT) {
  const { data, error } = await supabase.rpc('admin_list_content_gap_reports', { p_limit: limit })
  if (error) throw error
  return data || []
}

/** Trigger the content-gap-report edge function on demand (admin button). */
export async function generateContentGapReportNow() {
  return invokeEdgeJson(
    GENERATE_CONTENT_GAP_REPORT,
    { mode: 'manual' },
    {
      errorMessage: 'Failed to generate content-gap report',
    }
  )
}
